import type { TWsBackoffStrategy } from "../types";

export function makeBackoffStrategy(cfg: {
  baseDelayMs: number;
  maxDelayMs: number;
  jitterRatio: number;
}): TWsBackoffStrategy {
  return (attempt: number) => {
    const exp = Math.max(0, attempt - 1);
    const base = Math.min(cfg.maxDelayMs, cfg.baseDelayMs * 2 ** exp);
    const jitter = Math.floor(base * cfg.jitterRatio * Math.random());
    return base + jitter;
  };
}
